import { CircularProgress, Grid, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPlayersByTeamId } from '../../../../actions/players.js'
import CreatePlayerModal from '../../../../dsasComponents/feuillematch/CreatePlayerModal.js'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import Item from './Item.js'

const SelectPlayerInOtherTeam = ({onSelect, filter, selected, match, searchFilter}) => {
    
    const [team, setTeam] = useState()
    const [players, setPlayers] = useState()

    useEffect(() => {
        if(!match || !filter)
            return

            let team = match.homeTeam._id !== filter ? match.homeTeam : match.awayTeam
            setTeam(team)

            if(isFeuilleDeMatchFull(match)){
                let playersTeam1 = [...match.homeHolders].concat([...match.homeSubstitutes])
                let playersTeam2 = [...match.awayHolders].concat([...match.awaySubstitutes])
    
                let players = match.homeTeam._id !== filter ? playersTeam1 : playersTeam2
                setPlayers(players.sort((a,b) => a.numero - b.numero))
            }else{
                let players = match.homeTeam._id !== filter ? match.homeTeam.players : match.awayTeam.players
                setPlayers(players.sort((a,b) => a.number - b.number || a.lastname.localeCompare(b.lastname)))
            }

    }, [match])

    return (
        match && team && players? <>
                    <Stack  spacing={2} alignItems="center">
                    {team && !isFeuilleDeMatchFull(match) && <CreatePlayerModal teamId={team._id} discipline={match.discipline} provider={match.provider} match={match}/>}
                        {players && players.sort((a,b) => a.numero - b.numero)
                        .filter(p => p.firstname.toUpperCase()
                        .includes(searchFilter.toUpperCase()) 
                        || p.lastname.toUpperCase()
                        .includes(searchFilter.toUpperCase()))
                        .map((player) => 
                        <Item selected={selected} 
                        onSelect={onSelect}
                        value= {`${(player.numero!==null && player.numero!==undefined) ? 
                                    player.numero + ' - ' : 
                                     (player.number!==null && player.number!==undefined ? player.number +' - ' : '')}
                        ${player.lastname.toUpperCase()} ${player.firstname}`} 
                        id={player._id}/>)}
                    </Stack>
                    </>
             : <CircularProgress/>
    )

}

export default SelectPlayerInOtherTeam